import { useMemo } from 'react';
import { Identity } from '@/auth';
import { selectAuth } from '@/auth/store';
import { isAllUsersUnlocked } from '@/config/config';
import { useAppSelector } from './use-app-selector';

/**
 * True when the user may complete UI steps that are otherwise reserved for the
 * provider identity: actual provider, institution (HDO) representative session,
 * or env-based unlock for development.
 */
export const useCanAccessProviderLockedSteps = (): boolean => {
  const { authVariables, currentKey } = useAppSelector(selectAuth);

  return useMemo(() => {
    if (isAllUsersUnlocked()) {
      return true;
    }
    if (currentKey === null) {
      return false;
    }
    const vars = authVariables[currentKey];
    if (!vars) {
      return false;
    }
    if (vars.identity === Identity.Provider) {
      return true;
    }
    if (vars.isInstitution === true) {
      return true;
    }
    return false;
  }, [authVariables, currentKey]);
};
